import React, { useRef } from 'react'
import { pluralizeToString } from 'lib/string/pluralize'
import { generateOfferPageRoom, OfferPageFilterType, OfferPageState } from 'contexts/OfferPage/offerPageStateReducer'
import { withOfferPageAndReduxState } from 'contexts/OfferPage/withOfferPageState'
import ModalBody from 'LuxKit/Modal/ModalBody'
import ModalHeader from 'LuxKit/Modal/ModalHeader'
import FlashMobileStickyHeaderFilters from 'components/OfferPage/FlashHotel/FlashHotelMobileVariant/FlashMobileStickyHeaderFilters'
import MobileMultipleRoomsBookingContent from '../MobileMultipleRoomsBookingContent'

interface Props {
  rooms?: Array<App.RoomOccupants>
  activeFilter?: OfferPageFilterType
  onClose: () => void
  onBack?: () => void
}

const defaultRooms = [generateOfferPageRoom()]

function MobileMultipleRoomsBookingSelectRoomsModal(props: Props) {
  const { rooms = defaultRooms, activeFilter, onClose, onBack } = props

  const isConfirmStep = activeFilter === 'multiRoomConfirm'

  const headerRef = useRef<HTMLDivElement | null>(null)

  return (
    <>
      <ModalHeader
        title={isConfirmStep ? 'Confirm room selection' : `Select your ${pluralizeToString('room', rooms.length)}`}
        onCloseButtonClick={onClose}
        onBackButtonClick={onBack}
      >
        <FlashMobileStickyHeaderFilters onAfterCloseCapacity={onClose} ref={headerRef} />
      </ModalHeader>
      <ModalBody>
        <MobileMultipleRoomsBookingContent scrollToSelections headerRef={headerRef} />
      </ModalBody>
    </>
  )
}

type MappedProps = Pick<Props, 'rooms' | 'activeFilter'>

export default withOfferPageAndReduxState((state: OfferPageState): MappedProps => ({
  rooms: state.rooms,
  activeFilter: state.activeFilter,
}), MobileMultipleRoomsBookingSelectRoomsModal)
